export { default as devOpsKnowBgSvg } from './DevOpsKnowBg.svg';
export { default as technologiesToolsBgSvg } from './TechnologiesToolsBg.svg';
export { default as howWorksBg } from './howWorksBg.svg';
export const itInfrastructureImage = require('./ItInfrastructureImage.png?webp');
export const devOpsImage = require('./devOps.jpg?webp');
export const devOpsImage2x = require('./devOps-2x.jpg?webp');
export const howWorksImage = require('./howWorks.jpg?webp');
export const howWorksImage2x = require('./howWorks-2x.jpg?webp');
export const solutionsImage = require('./solutionsImage.jpg?webp');
export const solutionsImage2x = require('./solutionsImage-2x.jpg?webp');
export const devOpsKnowImage = require('./DevOpsKnowImage.png?webp');
export const technologiesToolsImage = require('./TechnologiesTools.png?webp');
export const heroBgDark = require('./hero-bg-dark.png?webp');
export const heroBgLight = require('./hero-bg-light.png?webp');
export const heroPhone1x = require('./phone-1x.png?webp');
export const heroPhone2x = require('./phone-2x.png?webp');
